export default __webpack_public_path__ + "static/media/Canadian National Railway - Logo.f8027cc4.png";